export const module = {
  info: {
    name: 'voip-testing-numbers',
    caption: 'voip testing numbers',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,

}

export default module
